import PropTypes from 'prop-types';
import React from 'react';
import { isFunction } from 'lodash';
import classnames from 'classnames';
import { compose, withProps } from 'recompose';

export const enhance = compose(
	withProps(({ getRef }) => ({
		getRef: () => (t) => {
			if (isFunction(getRef)) {
				getRef(t);
			}
		},
	})),
);

export function CoreOption({ value, display, disabled = false }) {
	return (
		<option
			value={value}
			disabled={disabled}
		>
			{display}
		</option>
	);
}

CoreOption.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	display: PropTypes.string,
	disabled: PropTypes.bool,
};

export function CoreSelectBox({
	options,
	value,
	getRef,
	className,
	disabled,
	id,
	onChange,
	onFocus,
}) {
	return (
		<select
			ref={getRef}
			className={classnames('ph-selectbox', className)}
			disabled={disabled}
			id={id}
			onChange={onChange}
			onFocus={onFocus}
			value={value}
		>
			{options.map((option) => (
				<CoreOption
					key={option.value}
					{...option}
				/>
			))}
		</select>
	);
}

CoreSelectBox.propTypes = {
	// an arry of CoreOption objects
	options: PropTypes.arrayOf(PropTypes.shape(CoreOption.propTypes)),
	/** The default selected option. This value should match a value in the options list */
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/** Function will be called with the ref of the final <select> element */
	getRef: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
};

CoreSelectBox.defaultProps = {
	options: [],
};

export default enhance(CoreSelectBox);
